import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, Inject} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {
        SolutionParticipationSummaryData,
        SolutionParticipationSalesData,
        SolutionParticipationCasesData,
        SalesTrendCell,
        SolutionGroupCell,
        SolutionParticipationTableRow,
        LocationComplianceCell,
        SolutionParticipationSummaryCells,
        solutionParticipationSummaryFilter,
        SolParticipationSummary,
        SPSummaryFilterOptions
        } from './types/solution-participation-types';
import { skip, Subscription } from 'rxjs';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SolutionParticipationService } from 'src/app/features/solution-participation-details/service/solution-participation.service';
import * as _ from 'lodash';
import { MatSort, Sort } from '@angular/material/sort';
import { MixpanelService } from "../../core/services/mixpanel.service";
import { ContractModel } from 'src/app/global/contract-filter-model';
import { CustomDateRange } from 'src/app/global/filter-options-types';
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';
import { TooltipService } from 'src/app/shared/services/tooltip.service';
import { CurrencySymbolPipe } from 'src/app/core/pipes/currency-symbol.pipe';


@Component({
    selector: 'solution-participation-details',
    templateUrl: './solution-participation-details.component.html',
    styleUrls: ['./solution-participation-details.component.scss'],
    standalone: false
})
export class SolutionParticipationDetailsComponent implements OnInit, OnDestroy {

  // Setter-based ViewChild will update the paginator reference whenever the MatPaginator is recreated
  private _paginator!: MatPaginator;
  @ViewChild(MatPaginator) set paginator(paginator: MatPaginator) {
    this._paginator = paginator;
    if (this.dataSource) {
      this.dataSource.paginator = paginator;
    }
  }
  get paginator(): MatPaginator {
    return this._paginator;
  }
  @ViewChild(MatTable) table!: MatTable<SolutionParticipationTableRow>;
  @ViewChild(MatSort) matSort!: MatSort;

  //constants
  private static readonly LOCATION_VIEW: string = "location-view";
  private static readonly SOLUTION_GROUP_VIEW: string = "solution-group-view";

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;
  summaryAdvancedFiltersSubscription: Subscription| undefined;
  solutionParticipationV2Subscription: Subscription | undefined;
  customDateRange : CustomDateRange | undefined;

  pageTitle : string = "Solution Participation";
  pageSubTitle : string = "";

  displayLoader : boolean = true;
  displayGraphLoader : boolean = true;
  displayLoaderForFilterData : boolean = false;
  displayWidgetLoader: boolean = true;
  isCurrencyLoading: boolean = false;

  casesAPIData:SolutionParticipationTableRow[] | any = [];
  salesAPIData:SolutionParticipationTableRow[] | any = [];
  summaryAPIData:SolParticipationSummary = {solutionParticipationSummary:[], solutionParticipationSolutionsPerLocationAvg: 0};
  data : SolutionParticipationTableRow[] = [];
  filteredData : SolutionParticipationTableRow[] = [];
  topSolutionGroups: SolutionParticipationTableRow[] = [];
  topSalesData: SolutionParticipationTableRow[] = [];
  dataSource: MatTableDataSource<SolutionParticipationTableRow> = new MatTableDataSource(this.data);

  displayColumns : string[] = ['solutionGroup', 'locationCompliance', 'sales', 'salesTrend', 'linksToViewBy'];

  pageSizeOptions :number[] = [10, 15, 30, 45, 60, 90];
  currentPage: number = 0;
  pageNumberLabel : string = '_ of _';

  searchTerm: string = '';
  isCasesSelected: boolean = false;

  //Use this to track how to populate the data in the table
  sortState = 0;
  //This can probably be restructured into an enum-like data structure
  //Key:
  //  0 - normal sorting
  //  1 - numeric sorting from lowest to highest sales numbers
  //  2 - numeric sorting from highest to lowest sales numbers
  //  3 - numeric sorting from lowest to highest usage numbers
  //  4 - numeric sorting from highest to lowest usage numbers

  //Tracks current solution participation sort type  - default is "Sales"
  currSortType : string = "Sales";

  //Length of cases and sales data arrays
  numCasesData: number = 0;
  numSalesdata: number = 0;
  // maximum sales/cases of selected data
  maxSalesOfSelected: number = 0;
  maxCasesOfSelected: number = 0;
  // 'current' sales/cases of filtered data
  totalSalesOfFiltered: number = 0;
  totalCasesOfFiltered: number = 0;

  solutionGroupNames: string[] = [];
  usageValues: number[] = [];
  usageTotalValues: number[] = [];
  totalLocationsValues: number[] = [];
  numSolutions: number = 0;
  salesSolutiongroups: string[] = [];
  salesData: number[] = [];
  opportunityValues: number[] =[];
  periodValue: string = '';
  periodStrings : any = {
    'Prior Month' : "Last Month",
    'R3' : "Last 3 Months",
    'R6': "Last 6 Months",
    'R12': "Last 12 Months",
    'R24': "Last 24 Months",
    'YTD': "Year To Date",
    'Custom':  'Custom Range'
  }

  //For tracking duration of search input's focus (ie usage)
  focusStartTime: Date | null = null;

  advancedFilterData: solutionParticipationSummaryFilter[] = [];
  selectedAdvancedFilters: SPSummaryFilterOptions = {
    "platform": [],
    "solution": [],
    "productGroup": [],
    "productName": [],
    "productSku" : [],
    "brand": []
  };
  toggleAdvancedFilterSelection : boolean = false;

  currencySymbol: string = '';
  currencyCode: string = '';

  // This flag looks like it is used to toggle the page contents between solution view and location view.
  // Should evaluate usage and rename appropriately.
  solutionViewEnabled: boolean = false;
  //TODO: Remove this once neptune design is implemented for Solution Participation Details US:624368
  disableLocationView:boolean = false;
  tabSelected: string = SolutionParticipationDetailsComponent.LOCATION_VIEW;
  isQsrFrsDivision: boolean = false;
  private currencySubscription: Subscription | undefined;
  private tooltipSub: Subscription | undefined;
  public currentOpenTooltipId: string | null = null;

  constructor(
    private _filterService: FiltersService,
    private _solutionParticipation : SolutionParticipationService,
    private _router : Router,
    private _route: ActivatedRoute,
    private mixpanelService: MixpanelService,
    private _currencyUomService: CurrencyUomService,
    private _cdr: ChangeDetectorRef,
    @Inject(FEATURE_FLAGS) private _featureFlags: FeatureFlags,
    private _tooltipService: TooltipService,
    private _currencySymbolPipe: CurrencySymbolPipe
    ) { }

  get isRefreshedSolutionParticipationUIEnabled() {
    return this._featureFlags.enableRefreshedSolutionParticipationUI;
  }

  get useRefreshedSolutionParticipationUI(): boolean {
    return this.isRefreshedSolutionParticipationUIEnabled
      && this.tabSelected === SolutionParticipationDetailsComponent.LOCATION_VIEW;
  }

  async ngOnInit() {
    // Subscriptions
    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);
    this.filtersSubscription = this._filterService.customDateRangeObservable.subscribe(f => this.customDateRange = f);
    // subscribe to tooltip service to track which row menu is open
    this.tooltipSub = this._tooltipService.currentOpen$.subscribe(id => {
      this.currentOpenTooltipId = id;
      // trigger change detection if needed
      try { this._cdr.detectChanges(); } catch(e) {}
    });

    // Check for tab query parameter from breadcrumb navigation
    const queryParamTab = this._route.snapshot.queryParams['tab'];

    if (this.filters !== undefined) {
      this.getCurrency();

      const regions = this.filters?.regions ?? [];
      const hasMultipleRegions = regions.length > 1;

      // Solution View is enabled when Location View is disabled
      this.solutionViewEnabled = this.disableLocationView;
      this.isQsrFrsDivision = this.filters.division === 'QSR' || this.filters.division === 'FRS';

      // Determine which tab to select
      // If navigating from breadcrumb with query param, use that; otherwise determine based on region config
      this.tabSelected = queryParamTab || this.determineSelectedTab(false, hasMultipleRegions || this.isSupportedSingleRegion(regions));

      // Only override when coming from breadcrumb
      if (queryParamTab) {
        this.solutionViewEnabled = this.tabSelected === SolutionParticipationDetailsComponent.SOLUTION_GROUP_VIEW;
      }

      // In the case of page changes, all the summary fields must be reset to 0
      this.resetSummarySectionToZero();

      this.currencySubscription = this._currencyUomService.selectedCurrency$.pipe(skip(1)).subscribe(async () => {
        this.isCurrencyLoading = true;
        this.displayLoader = true;
        // In the case of page changes, all the summary fields must be reset to 0
        this.resetSummarySectionToZero();

        this._currencyUomService.setCurrencyLoading(true);
        // Fetch Data from API for Summary Table
        await this.fetchDataFromAPI();
        this._currencyUomService.setCurrencyLoading(false);

        // Set data source for default sort type (this.data)
        this.loadDataForCurrentSortType();

        // Calculate Summary Section values
        this.calculateSummaryValues();

        //Calculate values for top solutions graph
        this.calculateValuesForSummaryGraphs();

        this.getCurrency();

        this.runToggleSettings(false);
        this._cdr.detectChanges();
        this.displayLoader = false;
        this.isCurrencyLoading = false;
      });

      // Subscribe to advanced filters for Summary Page
      this.summaryAdvancedFiltersSubscription = this._solutionParticipation.getSummaryAdvancedFilters().subscribe(advFilter => this.selectedAdvancedFilters = advFilter);

      // Get Advanced Filter Options for Summary Page
      this.displayLoaderForFilterData=true;
      this.advancedFilterData = await this.getAdvancedFilterData();
      this.displayLoaderForFilterData=false;

      // Reset Advanced Filters for drill down pages
      this._solutionParticipation.resetLocationAdvancedFilters();
      this._solutionParticipation.resetProductAdvancedFilters();

      this.displayLoader = true;
      this.displayGraphLoader = true;

      // Fetch Data from API for Summary Table
      await this.fetchDataFromAPI();

      // Set data source for default sort type (this.data)
      this.loadDataForCurrentSortType();

      // Calculate Summary Section values
      this.calculateSummaryValues();

      // Push metrics to mixpanel
      this.trackMixPanelEvent('Solution Participation Loaded');

      // Start active duration tracking
      this.mixpanelService.initializeActiveDurationTracking();

      //Calculate values for top solutions graph
      this.calculateValuesForSummaryGraphs();

      // When No filters applied, the total sales/cases = max sales/cases of selected
      this.totalSalesOfFiltered = this.maxSalesOfSelected;
      this.totalCasesOfFiltered = this.maxCasesOfSelected;

      this.displayLoader = false;
      this.displayGraphLoader=false;
    } else{
      alert('Please apply filters before navigating to Solution Participation')
      this._router.navigate(['/filter']);
    }
  }

  private resetSummarySectionToZero() {
    this._solutionParticipation.sumProducts = 0;
    this._solutionParticipation.sumLocations = 0;
    this._solutionParticipation.sumCases = 0;
    this._solutionParticipation.solutionsPerLocation = 0;
    this._solutionParticipation.numSolutions = 0;
    this._solutionParticipation.sumSales = 0;
  }

  private calculateValuesForSummaryGraphs() {
    if (this.filters?.period !== undefined) {
      let period = this.filters!.period;
      this.topSolutionGroups = this.data.sort((a: SolutionParticipationTableRow, b: SolutionParticipationTableRow) => parseFloat(b.LocationComplianceCell.compliance) - parseFloat(a.LocationComplianceCell.compliance)).slice(0, 10);
      this.solutionGroupNames = this.topSolutionGroups.map((item: SolutionParticipationTableRow) => item.SolutionGroup.name);
      this.usageValues = this.topSolutionGroups.map((item: SolutionParticipationTableRow) => Math.round(parseFloat(item.LocationComplianceCell.compliance)));
      this.usageTotalValues = this.topSolutionGroups.map((item: SolutionParticipationTableRow) => item.LocationComplianceCell.complianceCount as number);
      this.totalLocationsValues = this.topSolutionGroups.map((item: SolutionParticipationTableRow) => item.LocationComplianceCell.totalCount as number);

      this.topSalesData = this.data.sort((a: SolutionParticipationTableRow, b: SolutionParticipationTableRow) => b.Sales - a.Sales).slice(0, 10);
      this.salesSolutiongroups = this.topSalesData.map((item: SolutionParticipationTableRow) => item.SolutionGroup.name);
      this.salesData = this.topSalesData.map((item: SolutionParticipationTableRow) => Math.round(item.Sales));
      this.opportunityValues = this.topSalesData.map((item: SolutionParticipationTableRow) => Math.round(item.Opportunity));
      this.periodValue = this.periodStrings[period];
    }
  }

  private async fetchDataFromAPI() {
    const [summaryData, salesData, casesData] = await Promise.all([this.getSummaryData(this.selectedAdvancedFilters), this.getSalesData(this.selectedAdvancedFilters), this.getCasesData(this.selectedAdvancedFilters)]);

    this.salesAPIData = salesData;
    this.casesAPIData = casesData;
    this.summaryAPIData = summaryData;
  }

  private setMaxCases(casesData: any) {
    this.maxCasesOfSelected = 0;
    for (let i = 0; i < casesData.length; i++) {
      this.maxCasesOfSelected += casesData[i].totalCases;
    }
  }

  private setMaxSales(salesData: any) {
    this.maxSalesOfSelected = 0;
    for (let i = 0; i < salesData.length; i++) {
      this.maxSalesOfSelected += salesData[i].totalSales;
    }
  }

  async onSelectedFiltersChange(selectedFilters:{ [id: string]: string[] }) {
    this._solutionParticipation.setSummaryAdvancedFilters(selectedFilters as SPSummaryFilterOptions);
    this.displayLoader = true;
    this.resetSummarySectionToZero();
    await this.fetchDataFromAPI();
    this.loadDataForCurrentSortType();
    // Calculate Summary Section values
    this.calculateSummaryValues();
    //Calculate values for top solutions graph
    this.calculateValuesForSummaryGraphs();
    this.displayLoader = false;
  }

  ngOnDestroy() {
    this.currencySubscription?.unsubscribe();
    this.mixpanelService.stopTrackingActiveTime();
    this.mixpanelService.trackPageView(this.pageTitle); //send page view event, which includes Page Name and Active Duration
    this.tooltipSub?.unsubscribe();
  }

  get sumLocations(): number {
    return this._solutionParticipation.sumLocations;
  }

  async getAdvancedFilterData() {
    return await this._solutionParticipation.getSummaryFilters();
  }

  async getSummaryData(advFilters: { [id: string]: string[] }){
    const summaryData = await this._solutionParticipation.getSummary(advFilters);
    return summaryData;
  }

  async getSalesData(advFilters: { [id: string]: string[] }){
    const salesData = await this._solutionParticipation.getSales(advFilters);
    // Set the max value of sales
    this.setMaxSales(salesData);
    return salesData;
  }

  async getCasesData(advFilters: { [id: string]: string[] }){
    const casesData = await this._solutionParticipation.getCases(advFilters);
    // Set the max value of cases
    this.setMaxCases(casesData);
    return casesData;
  }

  async onSearch(input: string){
    this.filteredData = this.data;

    //Only filter if length is greater than 3
    if (input.length >= 3) {
        this.filteredData = this.data.filter((item) => item.SolutionGroup.name.toUpperCase().includes(input.toUpperCase()));
        if (this.casesAPIData != undefined) {
          // Corresponding cases data using same filter
          let filteredCasesData = this.casesAPIData.filter((caseItem: any) => caseItem.solution && caseItem.solution.toUpperCase().includes(input.toUpperCase()));
          // Use this filtered cases data to update the number of cases in tab
          this.totalCasesOfFiltered = 0;
          for(let i=0; i<filteredCasesData.length; i++){
            this.totalCasesOfFiltered += filteredCasesData[i].totalCases;
          }
        }
        if (this.salesAPIData != undefined) {
          // Corresponding sales data using same filter
          let filteredSalesData = this.salesAPIData.filter((salesItem: any) => salesItem.solution && salesItem.solution.toUpperCase().includes(input.toUpperCase()));
          // Use this filtered sales data to update the number of sales in tab
          this.totalSalesOfFiltered = 0;
          for(let i=0; i<filteredSalesData.length; i++){
            this.totalSalesOfFiltered += filteredSalesData[i].totalSales;
          }
        }
    }
    else {
      // In the case that the data is not filtered, nums should be at their max
      this.totalSalesOfFiltered = this.maxSalesOfSelected;
      this.totalCasesOfFiltered = this.maxCasesOfSelected;
    }

    //(re)assigning dataSource (re)renders table, also (re)assign paginator
    this.dataSource = new MatTableDataSource(this.filteredData);
    this.dataSource.paginator = this.paginator;
    this.paginator?.firstPage();
    //need to reassign matSort
    this.dataSource.sort = this.matSort;
}

  parseSalesData(summaryData: SolutionParticipationSummaryData[], inputData: SolutionParticipationSalesData[], dateRangeCode: string) {
    let xAxisInfo = this._resetDataAndGetMonths(dateRangeCode);
    let salesDataMap = this._createDataMapSales(inputData);

    for (let spSummary of summaryData) {
      let salesData = salesDataMap[spSummary.solution];
      let sumCells: SolutionParticipationSummaryCells = this._createSummaryCells(spSummary, xAxisInfo[1]);

      let row : SolutionParticipationTableRow = {'SolutionGroup':sumCells.sgCell, 'LocationComplianceCell':sumCells.lcCell, 'Sales':salesData.totalSales, 'SalesTrend':sumCells.trendCell, 'ShowLinksToViewBy':false, 'Opportunity': (salesData.totalSales/ Number(sumCells.lcCell.complianceCount)) * Number(sumCells.lcCell.nonComplianceCount)};

      let monthDataMap: {[index:string]:number} = {};
      salesData.salesTrends.forEach((monthData) => {
        let tempMonthAbbr = this._solutionParticipation.mapMonthNumberToMonthAbbreviation(monthData.month);
        monthDataMap[tempMonthAbbr + '-' + monthData.year] = Math.round(monthData.saleByMonth * 100) / 100;
      });

      let yAxisCategories : any[] = [];

      for(let xAxisMonthYear of xAxisInfo[0]){
        yAxisCategories.push(monthDataMap[xAxisMonthYear] || '');
      }

      sumCells.trendCell = {xAxisCategories:xAxisInfo[1], yAxisCategories:yAxisCategories};
      row.SalesTrend = sumCells.trendCell;

      let rowCopy = _.cloneDeep(row);
      this.data.push(rowCopy);

      this.runToggleSettings(false);
    }
  }

  parseCasesData(summaryData: any, inputData: SolutionParticipationCasesData[], dateRangeCode: string) {
    let xAxisInfo = this._resetDataAndGetMonths(dateRangeCode);
    let casesDataMap = this._createDataMapCases(inputData);

    for (let spSummary of summaryData.solutionParticipationSummary) {
      let caseData = casesDataMap[spSummary.solution];
      let sumCells: SolutionParticipationSummaryCells = this._createSummaryCells(spSummary, xAxisInfo[1]);

      //assigned Opportunity to 0 here as we don't need it for cases data as of now and to fulfil type check
      let row : SolutionParticipationTableRow = {'SolutionGroup':sumCells.sgCell, 'LocationComplianceCell':sumCells.lcCell, 'Sales':caseData.totalCases, 'SalesTrend':sumCells.trendCell, 'ShowLinksToViewBy':false, 'Opportunity': 0};

      let monthDataMap: {[index:string]:number} = {};
      caseData.casesTrends.forEach((monthData) => {
        let tempMonthAbbr = this._solutionParticipation.mapMonthNumberToMonthAbbreviation(monthData.month);
        monthDataMap[tempMonthAbbr + '-' + monthData.year] = monthData.caseByMonth;
      });

      let yAxisCategories : any[] = [];

      for(let xAxisMonthYear of xAxisInfo[0]){
        yAxisCategories.push(monthDataMap[xAxisMonthYear] || '');
      }

      sumCells.trendCell = {xAxisCategories:xAxisInfo[1], yAxisCategories:yAxisCategories};
      row.SalesTrend = sumCells.trendCell;

      let rowCopy = _.cloneDeep(row);
      this.data.push(rowCopy);

      this.runToggleSettings(true);
    }
  }

  calculateSummaryValues() {
    if (this.casesAPIData && this.salesAPIData &&
      this.summaryAPIData.solutionParticipationSummary &&
      this.summaryAPIData.solutionParticipationSolutionsPerLocationAvg) {
      this.numSolutions = this.summaryAPIData.solutionParticipationSummary.length;
      let casesDataMap = this._createDataMapCases(this.casesAPIData);
      let salesDataMap = this._createDataMapSales(this.salesAPIData);

      for (let spSummary of this.summaryAPIData.solutionParticipationSummary) {
        let caseData = casesDataMap[spSummary.solution];
        let salesData = salesDataMap[spSummary.solution];

        this._solutionParticipation.sumCases += caseData.totalCases;
        this._solutionParticipation.sumSales += salesData.totalSales;
        this._solutionParticipation.sumProducts += spSummary.productCount;
      }

      this._solutionParticipation.solutionsPerLocation = this.summaryAPIData.solutionParticipationSolutionsPerLocationAvg;
      this._solutionParticipation.sumLocations =
          parseFloat(this.summaryAPIData.solutionParticipationSummary[0].compliantCount as string) +
          parseFloat(this.summaryAPIData.solutionParticipationSummary[0].nonCompliantCount as string);
      this._solutionParticipation.numSolutions = this.numSolutions;
    }
  }


  public runToggleSettings(isCases: boolean) {
    this.currSortType = isCases ? "Cases" : "Sales";
    this.isCasesSelected = isCases;

    this.sortOnLoad();

    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator = this.paginator;
  }

  private _resetDataAndGetMonths(dateRangeCode: string) {
    this.data = [];
    this.dataSource.data = [];
    let xAxisMonthsYears = this._determineMonthRange(dateRangeCode).reverse();
    let xAxisMonths = this._removeYearFromXAxis(xAxisMonthsYears);

    return [xAxisMonthsYears, xAxisMonths]
  }

  private _createDataMapCases(dataArray: SolutionParticipationCasesData[])  {
    let casesDataMap : {[index:string]:SolutionParticipationCasesData} = {};
    dataArray.forEach((caseData) => {
      casesDataMap[caseData.solution] = caseData;
    });

    return casesDataMap;
  }

  private _createDataMapSales(dataArray: SolutionParticipationSalesData[]) {
    let salesDataMap : {[index:string]:SolutionParticipationSalesData} = {};
    dataArray.forEach((salesData) => {
      salesDataMap[salesData.solution] = salesData;
    });

    return salesDataMap;
  }


  private _createSummaryCells(spSummary: SolutionParticipationSummaryData, xAxisMonths: string[]): SolutionParticipationSummaryCells {

  let sgCell : SolutionGroupCell= {'name':spSummary.solution, 'numOfProducts':spSummary.productCount};
  let lcCell : LocationComplianceCell = {'compliance':spSummary.compliant, 'nonCompliance':spSummary.nonCompliant, 'complianceCount':spSummary.compliantCount, 'nonComplianceCount': spSummary.nonCompliantCount, 'totalCount' : Number(spSummary.compliantCount) + Number(spSummary.nonCompliantCount)}
  // trendCell will be edited later
  let trendCell : SalesTrendCell = {xAxisCategories:xAxisMonths, yAxisCategories:[]}

  return {
    "sgCell":sgCell,
    "lcCell": lcCell,
    "trendCell": trendCell
  }

  }

  makeSPDPageSubtitle() {
    let totalNumOfProducts : number = 0;
    for(let row of this.dataSource.data){
      if(typeof row.SolutionGroup.numOfProducts == 'string'){
        totalNumOfProducts += parseInt(row.SolutionGroup.numOfProducts);
      }
      else{
        totalNumOfProducts += row.SolutionGroup.numOfProducts;
      }
    }
    this.pageSubTitle = `${totalNumOfProducts} Products Within ${this.dataSource.data.length} Solution Groups`;
    return this.pageSubTitle;
  }


  ViewByNavigation(groupBy:string, solutionGroupName: string, isNonUsage: boolean){
    this.mixpanelService.track("Solution Participation Location Details Drilldown Clicked", {
      "Usage": !isNonUsage
    })
        // Set the advanced filters drill down page
    this._solutionParticipation.updateDefaultFiltersForProduct(this.advancedFilterData, solutionGroupName);
    this._solutionParticipation.setSummaryAdvancedFilters(this.selectedAdvancedFilters);

    // close any open tooltip/ellipsis menu before navigating (deterministic close)
    try { this._tooltipService.close(); } catch (e) {}
    this._router.navigate(['/solution-participation-groupBy'],
      { queryParams:{ groupBy: groupBy,
                      solutionGroup: solutionGroupName,
                      isNonUsage: isNonUsage
                    }
      });
  }

  ViewByProducts(groupBy:string, solutionGroupName: string){
    // Set the advanced filters drill down page
    this._solutionParticipation.updateDefaultFiltersForProduct(this.advancedFilterData, solutionGroupName);
    this._solutionParticipation.setSummaryAdvancedFilters(this.selectedAdvancedFilters);
    // close any open tooltip/ellipsis menu before navigating (deterministic close)
    try { this._tooltipService.close(); } catch (e) {}
    this._router.navigate(['/solution-participation-groupBy-products'],
                          { queryParams:{ groupBy: groupBy,
                                          solutionGroup: solutionGroupName
                                        }
                          });

    this.mixpanelService.track('View By Product Details Clicked');
  }

  // Tooltip / row menu helpers using shared TooltipService
  toggleRowMenu(id: string) {
    this._tooltipService.toggle(id);
  }

  isRowMenuOpen(id: string) {
    return this.currentOpenTooltipId === id;
  }

  closeRowMenu() {
    this._tooltipService.close();
  }

  sortOnLoad(){
    this.sortState = 2; // --- Make the default highest to lowest sales
    this.data = this._sortData(this.data);

    //(re)assigning dataSource (re)renders table, also (re)assign paginator
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator = this.paginator;
    //need to reassign matSort
    this.dataSource.sort = this.matSort;
  }

  onSortChange(sortState: Sort){
    let sortField = sortState.active;
    if(sortField == "sales" && this.currSortType == "Cases") sortField = "cases";
    //Track that user is changing the sort
    this.mixpanelService.track(`Resorting Solution Participation Data using the ${sortField} field`);

    //  0 - alphabetical sorting of solution group names /!!!/ default when no other sort is selected, except onInit
    //  1 - numeric sorting from lowest to highest sales numbers
    //  2 - numeric sorting from highest to lowest sales numbers /!!!/ DEFAULT after ngOnInit
    //  3 - numeric sorting from lowest to highest usage numbers
    //  4 - numeric sorting from highest to lowest usage numbers
    //  5 - reverse alphabetical sorting of solution group names
    switch(sortState.active){
      case "locationCompliance":
        if(sortState.direction=='asc'){
          this.sortState = 3;
        }else if(sortState.direction=='desc'){
          this.sortState=4;
        }else{
          this.sortState=0;
        }
        break;
      case "sales":
        if(sortState.direction=='asc'){
          this.sortState = 1;
        }else if(sortState.direction=='desc'){
          this.sortState=2;
        }else{
          this.sortState=0;
        }
        break;
      case "solutionGroup":
        if(sortState.direction=='desc'){
          this.sortState=5;
        }else{
          this.sortState=0;
        }
        break;
      default:
        this.sortState = 0;
    }

    //(re)assigning dataSource (re)renders table, also (re)assign paginator
    this.dataSource = new MatTableDataSource(this._sortData(this.filteredData));
    this.dataSource.paginator = this.paginator;
    //need to reassign matSort
    this.dataSource.sort = this.matSort;
  }


  private _sortData(combinedData : SolutionParticipationTableRow[]) : SolutionParticipationTableRow[]{
    // Make a copy of the array to avoid modifying the original data
    let sortedData = combinedData.slice();
    //always sort data by solution group name (alphabetically) first
    sortedData.sort((a,b) =>  a.SolutionGroup.name.localeCompare(b.SolutionGroup.name));

    //Determines what kind of sorting we're doing before rendering the data
    switch (this.sortState) {
      case 0: //No sort
        // Skip the sorting workaround
        break;
      case 1: //Sales Num Rising Order
        sortedData = sortedData.sort((a, b) => a.Sales-b.Sales) //defaults to ascending
        this.sortState = 0;
        break;
      case 2: //Sales Num Descending Order
        sortedData = sortedData.sort((a, b) => a.Sales-b.Sales).reverse()
        this.sortState = 0;
        break;
      case 3: //Usage Rising Order
        sortedData = sortedData.sort((a,b) => parseFloat(a.LocationComplianceCell.compliance)-parseFloat(b.LocationComplianceCell.compliance));
        this.sortState = 0;
        break;
      case 4: //Usage descending order
        sortedData = sortedData.sort((a,b) => parseFloat(a.LocationComplianceCell.compliance)-parseFloat(b.LocationComplianceCell.compliance)).reverse();
        this.sortState = 0;
        break;
      case 5 :
        sortedData = sortedData.sort((a,b) => a.SolutionGroup.name.localeCompare(b.SolutionGroup.name)).reverse();
        this.sortState = 0;
        break;
    }
    return(sortedData);
  }


  //determines the dateRange we need for the SalesTrend graph
  //should return array like [..., 'Dec-2022', 'Jan-2023', 'Feb-2023', ...]
  private _determineMonthRange(dateRangeCode:string) : string[]{

    let retval : string[] = [];
    let year = new Date().getFullYear();
    let month = new Date().getMonth(); //getMonth() returns 0-11 inclusive
    let currentDate = new Date(year, month);

    if(dateRangeCode === 'Custom' && this.customDateRange){
      //work backwards from the endDate to the startDate
      let inbetweenDateMoment = this.customDateRange.endDate.moment.clone(); //clone the Moment to avoid mutating the original
      let previousDates : string[] = []; //going to hold return values formatted like 'Apr-2023'

      while(inbetweenDateMoment >= this.customDateRange.startDate.moment){
        //convert the Moment to a Date
        let inbetweenDate = inbetweenDateMoment.toDate();

        let previousDateArr = inbetweenDate.toLocaleDateString('en-US', {month: "short", year: "numeric"}).split(' '); //becomes formatted like "Apr 2023", then split into array
        let stringMonth = previousDateArr[0]; //3 letter Month ('Jan', 'Feb', 'Mar'...)
        let stringYear = previousDateArr[1]; //4 digit year as a string
        previousDates.push(stringMonth + '-' + stringYear); //format like 'Apr-2023'

        inbetweenDateMoment = inbetweenDateMoment.subtract(1, 'month'); //go back one month
      }

      return previousDates;
    }

    let howManyMonthsBack = 0;
    switch(dateRangeCode){
      case 'Prior Month':
        howManyMonthsBack = 1;
        break;
      case 'R3':
        howManyMonthsBack = 3;
        break;
      case 'R6':
        howManyMonthsBack = 6;
        break;
      case 'R12':
        howManyMonthsBack = 12;
        break;
      case 'R24':
        howManyMonthsBack = 24;
        break;
      case 'YTD':
        howManyMonthsBack = month;
        break;
    }

    let newDate = currentDate;
    let previousDates : string[] = [];
    for(let i=0; i<howManyMonthsBack; i++){

      let previousMonth = newDate.getMonth() - 1;
      if(previousMonth < 0){ //so if we reach -1
        previousMonth = 11; // 11=December
        year = year-1;
      }

      newDate = new Date(year, previousMonth);

      let previousDateArr = newDate.toLocaleDateString('en-US', {month: "short", year: "numeric"}).split(' '); //becomes formatted like "Apr 2023", then split into array
      let stringMonth = previousDateArr[0] //3 letter Month ('Jan', 'Feb', 'Mar'...)
      let stringYear = previousDateArr[1] //4 digit year as a string
      previousDates.push(stringMonth + '-' + stringYear) //format like 'Apr-2023'

    }

    retval=previousDates;

    return retval;
  }

  //@param xAxisMonths : string[] formatted like [..., 'Dec-2022', 'Jan-2023', 'Feb-2023', ...]
  //should return array like [..., 'Dec', 'Jan', 'Feb', ...]
  private _removeYearFromXAxis(xAxisMonths : string[]) : string[]{
    let justMonths :string[] = [];
    for(let month_year of xAxisMonths){
      justMonths.push(month_year.split('-')[0]);
    }

    return justMonths;
  }

  public async onCaseToggle() {
    if(this.currSortType == "Sales"){
      this.currSortType = "Cases";
      this.mixpanelService.track(`Switching to View Cases`);
    } else {
      this.currSortType = "Sales";
      this.mixpanelService.track(`Switching to View Sales`);
    }

    this.loadDataForCurrentSortType();
  }

  private loadDataForCurrentSortType() {
    if (this.filters !== undefined && this.filters?.period !== undefined) {

      // Set data source for default sort type
      if (this.currSortType === "Sales" && this.salesAPIData !== undefined && this.summaryAPIData != undefined) {
        this.parseSalesData(this.summaryAPIData.solutionParticipationSummary, this.salesAPIData, this.filters.period);
      }
      else if (this.currSortType === "Cases" && this.casesAPIData !== undefined && this.summaryAPIData != undefined) {
        this.parseCasesData(this.summaryAPIData, this.casesAPIData, this.filters.period);
      }
      else {
        this.data = [];
      }

      this.onSearch(this.searchTerm);
    }
  }

  public onSearchFocus(){
    this.focusStartTime = new Date();
  }

  public onSearchBlur(){
    if (this.focusStartTime) {
      const focusDuration = (new Date()).getTime() - this.focusStartTime.getTime();
      this.mixpanelService.track('Time spent on Search Box in milliseconds', { duration: focusDuration });
      this.focusStartTime = null;
    }
  }

  getCurrency() {
    this.currencyCode = this._currencyUomService.getCurrencyCode();
    this.currencySymbol = this._currencySymbolPipe.transform(this.currencyCode);
  }

  //Solution Participation V3
  changeTab(tab: string) {
    this.tabSelected = tab;
    this.solutionViewEnabled = this.tabSelected === SolutionParticipationDetailsComponent.SOLUTION_GROUP_VIEW;

    var tabName = this.tabSelected === SolutionParticipationDetailsComponent.SOLUTION_GROUP_VIEW ? 'Solution Group View' : 'Location View';
    this.trackMixPanelEvent(`Solution Participation - ${tabName} Tab Clicked`);
  }

  private trackMixPanelEvent(eventName: string){
    this.mixpanelService.track(eventName, {
      "Page Name": this.pageTitle,
      division: this.filters?.division,
      dataView: this.filters?.dataView,
      regionSelected: this.filters?.regions,
      countriesSelected: this.filters?.countries,
      H5s: this.filters?.topLevelContractGroup,
      H7s: this.filters?.secondLevelContractFilter,
      acctsSelected: this.filters?.accts,
      periodSelected: this.filters?.period,
      "Custom Date Range": this.filters?.dateRange,
      tabSelected: this.tabSelected == SolutionParticipationDetailsComponent.SOLUTION_GROUP_VIEW ? 'Solution Group View' : 'Location View'
    });
  }

  /**
   * Determines which tab should be selected based on region configuration.
   */
  private determineSelectedTab(hasUnsupportedRegion: boolean, isMultiRegionOrSupported: boolean): string {
    // Determine based on region configuration
    if (hasUnsupportedRegion) {
      // Unsupported regions require Solution Group View
      return SolutionParticipationDetailsComponent.SOLUTION_GROUP_VIEW;
    } else if (isMultiRegionOrSupported) {
      // Multiple regions or supported single regions use Location View
      return SolutionParticipationDetailsComponent.LOCATION_VIEW;
    } else {
      // Default fallback
      return SolutionParticipationDetailsComponent.SOLUTION_GROUP_VIEW;
    }
  }

  /**
   * Checks if the selected regions include supported single regions (NA, EU, AP, LA, IMEA).
   * @param regions - Array of selected region codes.
   * @returns True if there is only one selected region and it is supported; otherwise, false.
   */
  private isSupportedSingleRegion(regions: string[]): boolean {
    const supportedSingleRegions = ['NA', 'EU', 'AP', 'LA','IMEA'];
    return regions.length === 1 && supportedSingleRegions.includes(regions[0]);
  }
}
